<template>
	<div
		class="player"
		:style="'width:' + widthHeigt[0] + '%' + 'height:' + widthHeigt[1] + '%'"
	>
		<div class="video" id="tcplayer"></div>
	</div>
</template>

<script>
import { TcPlayer } from '@/utils/TcPlayer3.2.3'

export default {
  name: "TcPlayer",
  props: {
    widthHeigt: {
			type: Array,
			default: () => [100, 100]
    },
    liveData: {
			type: Object,
			default: () => ({})
    }
  },
  data() {
    return {
			player: null,
			dataSource: null
    };
  },
  watch: {
    liveData: {
      handler(newVal) {
        if (newVal.id) {
          this.play()
        }
      },
      deep: true
    }
  },
  methods: {
    play() {
			let str = this.liveData.liveUrl
			const mp4 = str.replace('.m3u8', '.mp4')
			this.playDestroy()
			// const controls = "system";
			// let u = navigator.userAgent;
			// let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;   //判断是否是 android终端
			// if (isAndroid) {
			// 	controls = "default";
			// }
			if (this.liveData.liveState === 2 && this.liveData.judgeContact && this.liveData.scope !== 4) {
				this.player = new TcPlayer("tcplayer", {
					controls: 'system',
					live: true,
					m3u8: str, //请替换成实际可用的播放地址
					flv: this.liveData.pullUrl, // flv用于PC平台的播放
					// rtmp: liveUrl,
					mp4,
					autoplay: true, //iOS 下 safari 浏览器，以及大部分移动端浏览器是不开放视频自动播放这个能力的
					poster: {
						style: 'stretch', // stretch | cover | default
						src: this.liveData.liveImgUrl
					},
					width: this.widthHeigt[0] + "%", //视频的显示宽度，请尽量使用视频分辨率宽度
					height: 'auto', //视频的显示高度，请尽量使用视频分辨率高度
					// clarity: "sd",
					listener: msg => {
						// console.log(msg)
						this.handleChange(msg)
					},
					wording: {
						2: '视频格式 Web 播放器无法解码。',
						3: '视频解码错误。',
						4: '当前系统环境不支持播放该视频格式。',
						5: '当前系统环境不支持播放该视频格式。',
						1001: '网络已断开',
						1002: '主播已下线',
						2032: '获取视频失败，请检查播放链接是否有效。',
						2048: '无法加载视频文件，跨域访问被拒绝。'
					}
				})
			} else if (this.liveData.liveState === 3 && this.liveData.judgeContact && this.liveData.playBackUrl) {
				// 回放
				if (!this.liveData.playBackUrl) return
				const p = {
					controls: 'system',
					live: false,
					autoplay: false,
					poster: {
						style: 'stretch', // stretch | cover | default
						src: this.liveData.liveImgUrl
					},
					listener: (msg) => {
						// console.log(msg)
						this.handleChange(msg)
					},
					width: this.widthHeigt[0] + "%", // 视频的显示宽度，请尽量使用视频分辨率宽度
					height: 'auto' // 视频的显示高度，请尽量使用视频分辨率高度
				}
				const pType = this.liveData.playBackType.toLocaleLowerCase()
				if (pType === 'mp4' || pType === 'flv') {
					p[pType] = this.liveData.playBackUrl
				} else if (pType === 'hls') {
					p.m3u8 = this.liveData.playBackUrl
				}
				this.player = new TcPlayer('tcplayer', p)
			}
		
    },
    playDestroy() {
			if (this.player) {
				this.player.destroy()
				this.player = null
			}
    },
		handleChange(msg) {
			if (msg.type === 'play') {
				this.$emit('toggle', false)
			}

			if (msg.type === 'pause') {
				this.$emit('toggle', true)
			}
		}
  },
  destroyed() {
		// 页面销毁，同时也销毁 TcPlayer
		this.playDestroy()
	}
};
</script>

<style lang="scss" scoped>
.player {
  width: 100%;
  height: 100%;
  ::v-deep .video {
    width: 100%;
    height: 100%;
    .vcp-player {
      width: 100%;
      height: 100%;
      video {
        width: 100%;
        /* height: 200px;
        object-fit: contain; */
      }
    }
	.vcp-poster-pic.cover {
		width: 100%;
		/* height: 200px; */
	}
  }
}
</style>
